module.exports = __webpack_public_path__ + "media/images/lb/997-68ecf9785a295d3318f109c563cd7212.svg";